import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=70700c8a&"
import script from "SKYXH/components/leftMenu.component?vue&type=script&lang=js&"
export * from "SKYXH/components/leftMenu.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports